/**
import { FavoritesList } from '@/types/apifuncs/covestMainApi';
import { FavoritesList } from '@/types/apifuncs/covestMainApi';
 * 
 * binanceSpot 이랑 innovation 이랑 확인하기 
 * 
 */

// spot header
export interface spotHeaderInfo {
  symbol: string
  price: string
  persent: string
  diff: string
  high: string
  low: string
  volume: string
  volumeUSDT: string
  markPrice: string
}

// Spot 출력용 티커
export interface spotTickerArray {
  symbol: string
  price: string
  rate: string
  quoteVolume: string
  Favorites?: boolean
  Order?: number
}

//
export interface spotTrade {
  tradeId: number
  price: string
  amount: string
  time: string
  maker: boolean
}

// 주문서(Order Book) 인터페이스
export interface spotObject {
  lastUpdateId: number // 마지막 업데이트 ID
  bids: string[][] // 매수 호가 리스트 (가격, 수량)
  asks: string[][] // 매도 호가 리스트 (가격, 수량)
}

// Spot Type 리스트
export enum SpotType {
  Binance = 'binance',
  Innovation = 'innovation',
}

export enum showSingleDouble {
  DOUBLE = 'double',
  BIDSINGLE = 'bidSignle',
  ASKSINGLE = 'askSignle',
}

// spot orderbook data
export interface OrderbookData {
  price: number
  quantity: string
  total: number
  percentage: number
}

export interface MergedSpotOpenOrder {
  marketType: 'Main' | 'New' // 마켓 타입
  symbol: string // 거래 쌍 (예: "BTCUSDT")
  orderId: string // 주문 ID
  clientOrderId: string // 클라이언트에서 설정한 주문 ID
  side: 'BUY' | 'SELL' | string // 매수/매도 방향
  type: 'LIMIT' | 'MARKET' | string // 주문 유형
  timeInForce: 'GTC' | 'IOC' | 'FOK' | string // 주문 만료 유형
  price: string // 주문 가격
  origQty: string // 원 주문 수량
  executedQty: string // 체결된 수량
  cummulativeQuoteQty: string // 누적된 거래 금액
  time: string // 주문 생성 시간 (timestamp)
  updateTime: string // 주문 업데이트 시간 (timestamp)
  status: 'NEW' | 'PARTIALLY_FILLED' | 'FILLED' | 'CANCELED' | 'PENDING_CANCEL' | 'REJECTED' | 'EXPIRED' | string // 주문 상태
  isWorking: boolean // 주문이 활성화 상태인지 여부
  orderPrice: string // 주문 가격 * 주문 수량
}

export interface MergedSpotAsset {
  coin?: string
  asset: string
  free: string
  locked: string
  usdtValue: string
}

export enum SpotOrderSide {
  Buy = 'BUY',
  Sell = 'SELL',
}

export enum SpotOrderType {
  Limit = 'LIMIT',
  Market = 'MARKET',
}
